import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { HowCategoryRatingModuleName } from '@/store/modules/modules'

export class HowCategoryRatingViewModel {
  private store = useStore()

  chartData: ComputedRef<{ labelChartData: string[][]; categoryRatingChartData: number[][]; maxRating: number }> =
    computed(() => this.store.getters[`${HowCategoryRatingModuleName}/chartData`])
  chartSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${HowCategoryRatingModuleName}/chartSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${HowCategoryRatingModuleName}/chartOptions`])
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${HowCategoryRatingModuleName}/hasData`])

  setChartData(chartData: {
    labelChartData: string[][]
    categoryRatingChartData: number[][]
    maxRating: number
  }): void {
    this.store.commit(`${HowCategoryRatingModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${HowCategoryRatingModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${HowCategoryRatingModuleName}/setChartOptions`, chartOptions)
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${HowCategoryRatingModuleName}/setHasData`, hasData)
  }
}
